import React, { memo } from 'react';
import classNames from 'classnames';
import { TalentProfileVisibilityPanel } from 'modules/talents';
import styles from './TabLayout.module.scss';

function TabLayout({
  children,
  tabs,
  containerClassName,
  menuClassName,
  showVisibilityPanel = true,
}) {
  const tabContainerClasses = classNames(styles.tabLayout, containerClassName);
  const tabMenuClasses = classNames(styles.tabMenu, menuClassName);

  return (
    <div className={tabContainerClasses}>
      <div className={tabMenuClasses}>{tabs}</div>
      <div className={styles.tabContent}>{children}</div>
      {showVisibilityPanel && (
        <div className={styles.requirementContent}>
          <TalentProfileVisibilityPanel />
        </div>
      )}
    </div>
  );
}

export default memo(TabLayout);
